<div class="auth-shell">
  <div class="auth-card">
    <div class="auth-brand">
      <img src="assets/img/logo.png" class="auth-brand-mark" alt="">
      <span class="auth-brand-word">Fusion</span>
    </div>

    <div class="auth-body">
      @switch (stage) {

        @case ('invalid') {
          <h2 class="auth-title">{{ 'AUTH.RESET_INVALID_TITLE' | translate }}</h2>
          <p class="auth-lede">{{ 'AUTH.RESET_INVALID_LEDE' | translate }}</p>
          <div class="auth-links"><a routerLink="/forgot-password">{{ 'AUTH.FORGOT_SUBMIT' | translate }}</a></div>
        }

        @case ('done') {
          <h2 class="auth-title">{{ 'AUTH.RESET_DONE_TITLE' | translate }}</h2>
          <!-- States plainly that MFA is still required, so the outcome is not a surprise. -->
          <p class="auth-lede">{{ 'AUTH.RESET_DONE_LEDE' | translate }}</p>
          <div class="auth-links"><a routerLink="/login">{{ 'AUTH.BACK_TO_SIGN_IN' | translate }}</a></div>
        }

        @case ('password') {
          <h2 class="auth-title">{{ 'AUTH.RESET_TITLE' | translate }}</h2>
          <p class="auth-lede">{{ 'AUTH.RESET_LEDE' | translate }}</p>

          @if (errorKeys.length) {
            <div class="alert alert-danger">
              @for (key of errorKeys; track key) { <div>{{ key | translate }}</div> }
            </div>
          }

          <form (ngSubmit)="submit()" #resetForm="ngForm">
            <div class="form-group">
              <label for="password">{{ 'AUTH.NEW_PASSWORD' | translate }}</label>
              <input type="password" class="form-control" id="password" name="password"
                     [(ngModel)]="password" autocomplete="new-password" required
                     [minlength]="minLength" #passwordField="ngModel">
              <p class="auth-note">{{ 'AUTH.PASSWORD_RULE' | translate:{ min: minLength } }}</p>
            </div>

            <div class="form-group">
              <label for="repeat">{{ 'USER.REPEAT_PASSWORD' | translate }}</label>
              <input type="password" class="form-control" id="repeat" name="repeat"
                     [(ngModel)]="repeat" autocomplete="new-password" required>
              @if (mismatch) {
                <div class="alert alert-danger">{{ 'USER.PASSWORD_MISMATCH' | translate }}</div>
              }
            </div>

            <div class="auth-actions">
              <button type="submit" class="btn btn-primary" [disabled]="!canSubmit">
                {{ 'AUTH.RESET_SUBMIT' | translate }}
              </button>
            </div>
          </form>
        }
      }
    </div>
  </div>
</div>
